
import { SET_EVENT_DATA, SET_EVENT_HALL,SET_LIVE_PRESENTATION,SET_PANEL_DISCUSSION,SET_ON_DEMAND, SET_ROUND_TABLE,SET_SPEAKERS}   from "../../ActionTypes/Event/eventActionTypes";

const initialState = {
  agenda_live:[],
  panel_discussion: [],
  round_tables:[],
  on_demand:[],
  speakers: [],
  speaker_count:0,
  exhibitor_count:0,
  participant_count:0

};


const eventData = (state = initialState, action: any) => {
  switch (action.type) {
      case SET_EVENT_DATA:
        return {
          ...state,
          ...action.payload
        };
    
      case SET_EVENT_HALL:
        return {
          ...state,
          event_hall: action.payload,
        };
      case SET_LIVE_PRESENTATION:
            return {
                ...state,
                agenda_live: action.payload,
        };
      case SET_PANEL_DISCUSSION:
        return {
            ...state,
            panel_discussion: action.payload,
        };  
      case SET_ON_DEMAND:
        return {
            ...state,
            on_demand: action.payload,
        }; 
      case SET_ROUND_TABLE:
        return{
          ...state,
          round_table:action.payload,
        }
      case SET_SPEAKERS:
      return {
        ...state,
        speakers: action.payload,
      };
      case "SET_SPEAKERS_COUNT":
      return {
        ...state,
        speaker_count: action.payload,
      };
      case "SET_EXHIBITOR_COUNT":
      return {
        ...state,
        exhibitor_count: action.payload,
      };
      case "SET_PARTICIPANT_COUNT":
      return {
        ...state,
        participant_count: action.payload,
      };
      
     
    default:
      return state;
  }
};




export default eventData;

